var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-tool"},[_c('div',{staticClass:"tool-right"},[_c('div',{staticClass:"tool-menu"},[_c('i',{staticClass:"el-icon-document-add",staticStyle:{"color":"rgb(40, 124, 176)"}}),_vm._v("\n      添加当前预设\n    ")])])])
}]

export { render, staticRenderFns }